import React from "react";
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin, FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";
import { IoMdSend } from "react-icons/io";
import logo from "../../assets/images/Logo for website/Mobile_white_font.png";

export default function Footer() {
  return (
    <footer className="bg-[#222] text-gray-300 pt-12 pb-6 px-4 md:px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {/* Brand Info & Description */}
        <div className="flex flex-col">
          <div className="flex items-center mb-4">
            <img
              src={logo}
              alt="MASHO Perfumes Logo"
              className="h-20 w-auto object-contain mr-3"
            />
            <h1 className="text-2xl font-bold text-[#D4AF37]">MASHO PERFUMES</h1>
          </div>
          <p className="text-sm mb-4">
            Crafting timeless fragrances for the modern soul. Discover luxury in every scent.
          </p>
          <div className="flex items-center mb-2">
            <FaPhone className="text-[#D4AF37] mr-2" />
            <span>MOHAMMED MASHOOD <br></br>+91 70259 59481</span>
          </div>
          <div className="flex items-center mb-2">
            <FaEnvelope className="text-[#D4AF37] mr-2" />
            <span>info@mashoperfumes.com</span>
          </div>
          <div className="flex items-start">
            <FaMapMarkerAlt className="text-[#D4AF37] mr-2 mt-1" />
            <span>Malappuram, Kerala, India - 676519</span>
          </div>
        </div>

        {/* Quick Links */}
        <div className="flex flex-col">
          <h4 className="text-lg font-semibold text-white mb-4 border-b border-[#D4AF37] pb-2">Quick Links</h4>
          <ul className="space-y-2">
            <li><a href="" className="hover:text-[#D4AF37] transition-colors">Home</a></li>
            <li><a href="/shop" className="hover:text-[#D4AF37] transition-colors">Shop</a></li>
            <li><a href="#" className="hover:text-[#D4AF37] transition-colors">Best Sellers</a></li>
            <li><a href="new-arrivals" className="hover:text-[#D4AF37] transition-colors">New Arrivals</a></li>
            <li><a href="/about" className="hover:text-[#D4AF37] transition-colors">About Us</a></li>
            <li><a href="/about" className="hover:text-[#D4AF37] transition-colors">Contact</a></li>
          </ul>
        </div>

        {/* Customer Service */}
        <div className="flex flex-col">
          <h4 className="text-lg font-semibold text-white mb-4 border-b border-[#D4AF37] pb-2">Customer Service</h4>
          <ul className="space-y-2">
            <li><a href="/shipping-policy" className="hover:text-[#D4AF37] transition-colors">Shipping Policy</a></li>
            <li><a href="/return-policy" className="hover:text-[#D4AF37] transition-colors">Return Policy</a></li>
            <li><a href="/refund-policy" className="hover:text-[#D4AF37] transition-colors">Refund Policy</a></li>
            <li><a href="/privacy-policy" className="hover:text-[#D4AF37] transition-colors">Privacy Policy</a></li>
            <li><a href="/terms-and-conditions" className="hover:text-[#D4AF37] transition-colors">Terms & Conditions</a></li>
            <li><a href="/tracking" className="hover:text-[#D4AF37] transition-colors">Track Order</a></li>
          </ul>
        </div>

        {/* Newsletter & Social */}
        <div className="flex flex-col">
          <h4 className="text-lg font-semibold text-white mb-4 border-b border-[#D4AF37] pb-2">Newsletter</h4>
          <p className="text-sm mb-4">
            Subscribe to get updates on new arrivals, special offers and other discount information.
          </p>
          <form className="flex mb-6">
            <input
              type="email"
              placeholder="Your email address"
              className="flex-1 px-4 py-2 rounded-l-sm text-gray-800 focus:outline-none focus:ring-1 focus:ring-[#D4AF37]"
              required
            />
            <button
              type="submit"
              className="bg-[#D4AF37] text-black px-4 py-2 rounded-r-sm hover:bg-[#C19B2E] transition-colors flex items-center"
            >
              <IoMdSend className="mr-1" />
            </button>
          </form>
          
          <h4 className="text-lg font-semibold text-white mb-4 border-b border-[#D4AF37] pb-2">Follow Us</h4>
          <div className="flex gap-4">
            <a href="#" className="bg-[#333] p-2 rounded-full hover:bg-[#D4AF37] transition-colors">
              <FaFacebook size={18} />
            </a>
            <a href="https://www.instagram.com/masho_perfumes/" className="bg-[#333] p-2 rounded-full hover:bg-[#D4AF37] transition-colors">
              <FaInstagram size={18} />
            </a>
            <a href="#" className="bg-[#333] p-2 rounded-full hover:bg-[#D4AF37] transition-colors">
              <FaTwitter size={18} />
            </a>
          </div>
        </div>
      </div>

      {/* Payment Methods & Copyright */}
      <div className="mt-12 pt-6 border-t border-gray-700">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex gap-4 mb-4 md:mb-0">
            <span className="text-sm">We accept:</span>
            <div className="flex gap-2">
              <div className="bg-white text-black px-2 py-1 rounded text-xs font-bold">UPI Payments</div>
              <div className="bg-white text-black px-2 py-1 rounded text-xs font-bold">Net Bankings</div>
            </div>
          </div>
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} MASHO Perfumes. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}